import _ from "lodash"
export default {
    methods: {
        parentCount(value) {
            let count = 0;
            let display = false;
            _.forEach(value.child, item => {
                _.forEach(item.child, itemChild => {
                    if (itemChild.notif == null) {
                        itemChild.notif = 0
                    }
                    count = count + parseInt(itemChild.notif);
                    if (count > 0) {
                        display = true
                    } else {
                        display = false
                    }
                })
            })

            return display
        }
    }
}